// Brand colors per crime category
// Used for badges, dividers, and accent elements across the site
export const CATEGORY_COLORS = {
  violent: { bg: '#DC2626', text: '#FFFFFF', tint: '#FEE2E2', name: 'Violent Crimes' },
  cyber: { bg: '#0891B2', text: '#FFFFFF', tint: '#CFFAFE', name: 'Cyber Crimes' },
  'white-collar': { bg: '#D97706', text: '#FFFFFF', tint: '#FEF3C7', name: 'Financial' },
  property: { bg: '#059669', text: '#FFFFFF', tint: '#D1FAE5', name: 'Family/Extramarital' },
  tragedy: { bg: '#1E3A8A', text: '#FFFFFF', tint: '#E0E7FF', name: 'Tragedy' },
  others: { bg: '#7C3AED', text: '#FFFFFF', tint: '#EDE9FE', name: 'Others' }
};

export const getCategoryColor = (slug) => CATEGORY_COLORS[slug] || CATEGORY_COLORS.others;

// Site-wide palette
export const PALETTE = {
  pageBg: '#FFF8F0',
  surface: '#FFFFFF',
  textPrimary: '#1A1A2E',
  textSecondary: '#525252',
  border: '#E5E5E5',
  accentRed: '#E63946',
  accentYellow: '#FFB703',
  accentBlue: '#2563EB',
  footerBg: '#1A1A2E'
};
